import { observer } from 'mobx-react';
import { autoinject, SubTopBar, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { SeqLogsDashboard } from './SeqLogsDashboard';

export interface ISeqLogsViewProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class SeqLogsView extends React.Component<ISeqLogsViewProps> {
    public render() {
        return (
            <>
                <Title>Seq Logs</Title>

                <SubTopBar>
                    <span className="nav-link fw-bold d-inline-block">Application Logs</span>
                </SubTopBar>

                <SeqLogsDashboard />
            </>
        );
    }
}
